import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: string;
  title: string;
  author: string;
  cover: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updateTime: string;
  category?: string;
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  status,
  rating,
  views,
  updateTime,
  category,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <article className="group" data-product-shop="">
      <Link to={`/article/${id}`} className="block cursor-pointer">
        <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4] bg-background-200">
          <img
            src={cover}
            alt={title}
            title={`${title} - 韩漫大全好看韩国漫画`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute top-2 left-2">
            <span
              className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                status === '连载中'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-secondary-500 text-background-50'
              }`}
            >
              {status}
            </span>
          </div>
          {category && (
            <div className="absolute top-2 right-2">
              <span className="text-xs px-2 py-0.5 rounded-full bg-background-50/80 text-foreground-600">
                {category}
              </span>
            </div>
          )}
          <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
            <span className="text-xs text-white/90">点击查看详情</span>
          </div>
        </div>

        <h3 className="font-semibold text-sm text-foreground-800 line-clamp-1 mb-1 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mb-2 line-clamp-1">{author}</p>

        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 w-3 h-3 flex items-center justify-center"></i>
            {rating}
          </span>
          <span>{formatViews(views)} 阅读</span>
          <span>{updateTime}</span>
        </div>
      </Link>
    </article>
  );
}